import { render } from "./OptionboardPhoneticTranscription.vue?vue&type=template&id=3422e550&scoped=true"
import script from "./OptionboardPhoneticTranscription.vue?vue&type=script&lang=js"
export * from "./OptionboardPhoneticTranscription.vue?vue&type=script&lang=js"

import "@/css/components/optionboard-phonetic-transcription.css?vue&type=style&index=0&id=3422e550&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3422e550"]])

export default __exports__